<script setup>
import ErrorHeader from '@/components/ErrorHeader.vue'
import { useGenerateImageVariant } from '@core/composable/useGenerateImageVariant'
import miscMaskDark from '@images/pages/misc-mask-dark.png'
import miscMaskLight from '@images/pages/misc-mask-light.png'

const authThemeMask = useGenerateImageVariant(miscMaskLight, miscMaskDark)

definePage({
  meta: {
    layout: 'blank',
    action: 'read',
    subect: 'Auth',
    public: true,
    pageTitle: 'Page Not Found',
  },
})

/* * **/
</script>

<template>
  <div class="misc-wrapper">
    <ErrorHeader
      title="Page Not Found :("
      description="We couldn't find the page you are looking for."
    />
    <VBtn
      to="/"
      class="mb-12"
      >Back to Home</VBtn
    >

    <VImg
      :src="authThemeMask"
      class="misc-footer-img d-none d-md-block"
    />
  </div>
</template>

<style lang="scss">
@use '@core/scss/template/pages/misc.scss';
</style>
